import React from "react";
import { Outlet } from "react-router-dom";
import TopBar from "./components/TopBar";

const OnboardingPage = () => (
  <div className="w-full min-h-screen flex flex-col items-center overflow-auto px-4 pt-16 pb-8"
    style={{ backgroundColor: "#FCFCFC" }}
  >
    <TopBar />
    <div className="flex flex-1 w-full max-w-[800px] flex-col items-center justify-center py-8">
      <Outlet />
    </div>
  </div>
);

export default OnboardingPage;
